export const TRUCK_TYPES = [
  "9 FT",
  "12 FT",
  "14 FT",
  "17 FT",
  "20 FT",
  "22 FT",
  "24 FT",
  "32 FT",
  "40 FT",
];

export const MATERIAL_TYPES = [
  "Frozen Food",
  "Dairy",
  "Fresh Produce",
  "Meat & Poultry",
  "Seafood",
  "Pharma / Vaccines",
  "Ice Cream",
  "Beverages",
  "Flowers",
  "Other Perishables",
];

export function tempTone(min) {
  if (min <= -18) return "bg-indigo-100 text-indigo-900 border-indigo-300 dark:bg-indigo-950/80 dark:text-indigo-200 dark:border-indigo-800";
  if (min < 2) return "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-950/80 dark:text-sky-200 dark:border-sky-800";
  if (min <= 8) return "bg-teal-100 text-teal-900 border-teal-300 dark:bg-teal-950/80 dark:text-teal-200 dark:border-teal-800";
  return "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/80 dark:text-amber-200 dark:border-amber-800";
}

export const COUNTRY_CODES = [
  { code: "+91", label: "IN +91" },
  { code: "+1", label: "US/CA +1" },
  { code: "+44", label: "UK +44" },
  { code: "+971", label: "AE +971" },
  { code: "+966", label: "SA +966" },
  { code: "+65", label: "SG +65" },
  { code: "+60", label: "MY +60" },
  { code: "+92", label: "PK +92" },
  { code: "+880", label: "BD +880" },
  { code: "+977", label: "NP +977" },
  { code: "+94", label: "LK +94" },
  { code: "+61", label: "AU +61" },
  { code: "+64", label: "NZ +64" },
  { code: "+49", label: "DE +49" },
  { code: "+33", label: "FR +33" },
  { code: "+39", label: "IT +39" },
  { code: "+34", label: "ES +34" },
  { code: "+31", label: "NL +31" },
  { code: "+81", label: "JP +81" },
  { code: "+86", label: "CN +86" },
  { code: "+82", label: "KR +82" },
  { code: "+27", label: "ZA +27" },
  { code: "+254", label: "KE +254" },
  { code: "+234", label: "NG +234" },
  { code: "+20", label: "EG +20" },
  { code: "+55", label: "BR +55" },
  { code: "+52", label: "MX +52" },
];

export function parsePhone(full) {
  const raw = (full || "").trim();
  const digits = raw.replace(/[^0-9]/g, "");
  if (!digits) return { dial: "+91", local: "" };
  const sorted = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  for (const c of sorted) {
    const cd = c.code.slice(1);
    if (digits.startsWith(cd) && digits.length - cd.length === 10) {
      return { dial: c.code, local: digits.slice(cd.length) };
    }
  }
  return { dial: "+91", local: digits.slice(-10) };
}

export function isValidPhone(full) {
  return parsePhone(full).local.length === 10;
}

export function waLink(phone, text) {  const digits = (phone || "").replace(/[^0-9]/g, "");
  const num = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${num}?text=${encodeURIComponent(text || "")}`;
}

export function waShare(text) {
  return `https://wa.me/?text=${encodeURIComponent(text || "")}`;
}

export function fmtDate(iso) {
  if (!iso) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${m[3]}/${months[parseInt(m[2], 10) - 1]}/${m[1]}`;
}

// Ordinal style for WhatsApp shares, e.g. "1st Sep 2026", "11th Sep 2026", "23rd Sep 2026"
export function fmtDateOrd(iso) {
  if (!iso) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const d = parseInt(m[3], 10);
  const ord = d % 100 >= 11 && d % 100 <= 13 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[d % 10] || "th";
  return `${d}${ord} ${months[parseInt(m[2], 10) - 1]} ${m[1]}`;
}

export function loadShareMessage(load) {
  const transport = load.poster_company || load.poster_name || "";
  const lines = [
    "🚚 *Loads Available*",
    `${load.origin} → ${load.destination}`,
    `Cargo: ${load.material_type} · ${load.weight}T`,
    `Temp: ${load.temp_min}°C to ${load.temp_max}°C`,
    `Truck needed: ${load.truck_type}`,
    `Pickup: ${fmtDateOrd(load.pickup_date)}`,
    `*${transport}*`,
    load.poster_phone ? `Contact: *${load.poster_phone}*` : "",
  ].filter(Boolean);
  return lines.join("\n") + "\n\n*also posted at ReeferSathi.com*";
}

export function loadsShareAllMessage(list) {
  const arr = [...(list || [])].sort((a, b) => String(a.pickup_date || "").localeCompare(String(b.pickup_date || "")));
  const blocks = arr.map((l, i) => [
    `${i + 1}) ${l.origin} → ${l.destination}`,
    `Cargo: ${l.material_type} · ${l.weight}T`,
    `Temp: ${l.temp_min}°C to ${l.temp_max}°C`,
    `Truck needed: ${l.truck_type}`,
    `Pickup: ${fmtDateOrd(l.pickup_date)}`,
  ].join("\n"));
  const first = arr[0] || {};
  const footer = [
    first.poster_company || first.poster_name ? `*${first.poster_company || first.poster_name}*` : "",
    first.poster_phone ? `Contact: *${first.poster_phone}*` : "",
  ].filter(Boolean).join("\n");
  return "🚚 *Loads Available*\n\n" + blocks.join("\n\n")
    + (footer ? "\n\n" + footer : "") + "\n\n*also posted at ReeferSathi.com*";
}

export function truckShareMessage(t) {
  const transport = t.poster_company || t.poster_name || "";
  const lines = [
    "❄️ *Vehicle's Available Today*",
    `${t.truck_type} at ${t.current_location}${t.destination ? " → " + t.destination : ""}`,
    `Capacity: ${t.capacity}T`,
    `Temp: ${t.temp_min}°C to ${t.temp_max}°C`,
    `Available: ${fmtDateOrd(t.available_date)}`,
    `*${transport}*`,
    t.poster_phone ? `Contact: *${t.poster_phone}*` : "",
  ].filter(Boolean);
  return lines.join("\n") + "\n\n*also posted at ReeferSathi.com*";
}

export function trucksShareAllMessage(list) {
  const arr = [...(list || [])].sort((a, b) => String(a.available_date || "").localeCompare(String(b.available_date || "")));
  const blocks = arr.map((t, i) => [
    `${i + 1}) ${t.truck_type} at ${t.current_location}${t.destination ? " → " + t.destination : ""}`,
    `Capacity: ${t.capacity}T`,
    `Temp: ${t.temp_min}°C to ${t.temp_max}°C`,
    `Available: ${fmtDateOrd(t.available_date)}`,
  ].join("\n"));
  const first = arr[0] || {};
  const footer = [
    first.poster_company || first.poster_name ? `*${first.poster_company || first.poster_name}*` : "",
    first.poster_phone ? `Contact: *${first.poster_phone}*` : "",
  ].filter(Boolean).join("\n");
  return "❄️ *Vehicle's Available Today*\n\n" + blocks.join("\n\n")
    + (footer ? "\n\n" + footer : "") + "\n\n*also posted at ReeferSathi.com*";
}
